import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { setStage } from 'slices/drawer'
import { updatePlanUpgrade } from 'slices/contract'
import { useFirebaseEvent } from 'hooks'
import { STATICS } from 'statics'
import { Checkbox, Button } from 'components'
import { formatCurrenctyWithoutSignal } from 'utils'
import { productService } from 'services'
import { EVENT_STATUS, FIREBASE_EVENTS } from 'app-constants'
import { FIDELITY_STAGES, SPECIAL_OFFER_TEXTS } from '../../constants'
import './style.scss'

export function SpecialOffer({ contractId, plan, cpfCnpj, phone }) {
  const [confirmation, setConfirmation] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { planName, planCode, value, velocity, campaignCode } = plan
  const { sendEvent } = useFirebaseEvent()
  const dispatch = useDispatch()
  const { confirmPlanUpgrade } = productService()

  function handleConfirmationChange() {
    setConfirmation(!confirmation)
  }

  async function handleSendOffer() {
    setIsLoading(true)

    try {
      await confirmPlanUpgrade({
        contractId,
        campaignCode,
        planName,
        document: cpfCnpj,
        phone,
        planCode,
      })
      dispatch(updatePlanUpgrade())
      dispatch(setStage(FIDELITY_STAGES.SUCCESS))
      sendEvent(FIREBASE_EVENTS.CLICK_ON_CONFIRM_OFFER_TERM_FIDELITY, EVENT_STATUS.SUCCESS)
    } catch (error) {
      console.error(error)
      dispatch(setStage(FIDELITY_STAGES.ERROR))
      sendEvent(
        FIREBASE_EVENTS.CLICK_ON_CONFIRM_OFFER_TERM_FIDELITY,
        EVENT_STATUS.ERROR,
        error?.response?.status
      )
    } finally {
      setIsLoading(false)
    }
  }

  function renderOfferTexts() {
    return (
      <div className='container-offer-conditions'>
        {SPECIAL_OFFER_TEXTS.map((item, index) => (
          <div key={index} className='content-offer-conditions'>
            <div className='icon-rounded-check'>
              <STATICS.CHECK_CIRCLE />
            </div>{' '}
            <span className='text-condition'>{item.text}</span>
          </div>
        ))}
      </div>
    )
  }

  function renderInformationsCardOffer() {
    return (
      <div className='content-special-offer'>
        <div className='container-label'>
          <div className='label-available-offer'>
            <div className='icon-percent-discount'>
              <STATICS.PERCENT_DISCOUNT />
            </div>{' '}
            Oferta disponível
          </div>
        </div>
        <div className='container-plan-information'>
          <div className='name-plan-information'>{velocity}</div>
          <span className='complement-text'>Para você navegar à vontade</span>
          <div className='content-price'>
            <span className='symbol-real'>R$</span>
            <span className='price'> {formatCurrenctyWithoutSignal(value)} </span>
            <span className='month'>/mês</span>
          </div>
        </div>
        {renderOfferTexts()}
      </div>
    )
  }

  function renderOfferTerm() {
    return (
      <div className='container-offer-term'>
        <span className='text-confirm-term'>Confirme para prosseguir</span>
        <Checkbox
          classNameCheckBox='checkbox-term'
          classNameInput='input-term'
          classNameLabel='label-term'
          label='Li e confirmo os detalhes da nova oferta.'
          onChange={handleConfirmationChange}
          checked={confirmation}
        />
      </div>
    )
  }

  function renderButtonConfirmation() {
    const CONFIRM_TEXT_ABOVE = 'Confirme acima para continuar'
    const CONFIRM_OFFER = 'Confirmar oferta'

    return (
      <div className='container-button-confirmation'>
        <Button
          type='button'
          className='button-confirmation'
          color='primary'
          disabled={!confirmation}
          onClick={handleSendOffer}
          isLoading={isLoading}
        >
          {confirmation ? CONFIRM_OFFER : CONFIRM_TEXT_ABOVE}
        </Button>
        <span className='offer-term-message'>Ao confirmar, você aceita os termos da oferta</span>
      </div>
    )
  }

  return (
    <div className='container-special-offer'>
      <div>
        {renderInformationsCardOffer()}
        {renderOfferTerm()}
      </div>
      {renderButtonConfirmation()}
    </div>
  )
}
